var r = function (e) {
    return e.defaultAvatar = "default", e.headerAvatar = "header", e.clientAvatar = "client", e;
  }(r || {}),
  t = function (e) {
    return e.s = "S", e.m = "M", e.l = "L", e;
  }(t || {});
export { r as AvatarKind, t as AvatarSize };